// extracted by mini-css-extract-plugin
export default {"space":"InputWindow_space__io0JN","active":"InputWindow_active__EuNuS","container":"InputWindow_container__V+teC","btn":"InputWindow_btn__VvW95"};